import * as React from 'react';
import * as InfiniteScroll from 'react-infinite-scroller';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { LProps, withLocalization } from '../utils/wrappers';
import StoryComponent from './StoryComponent';
import { Stories, Pagination, CompetitionPledge, Story } from '../userApi';
import { State, Modals, StoryQuery } from '../redux/state';
import actions from '../redux/actions';
import { connect } from 'react-redux';
import * as selectors from '../redux/selectors';
import StoryCreator from './StoryCreator';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import FlagStoryModal from './FlagStoryModal';
import UserIneligibleForPledge from './UserIneligibleForPledge';
import StoryPoints from './StoryPoints';
import FeedLiveRefresh from './FeedLiveRefresh';
import { Alert } from 'reactstrap';
import { StyleState } from '../utils/styles';

interface ManualProps {
  showPrompt?: boolean;
  /** When on a pledge page, pass the route pledge so the story form does not depend on storyQuery. */
  pledge?: CompetitionPledge;
}

interface Props extends ManualProps {
  stories: Stories;
  pagination: Pagination;
  pledge: CompetitionPledge;
  storyQuery: StoryQuery;
  eligible: boolean;
  modal: Modals;
  deleteStory: () => void;
  pageStories: (page: number) => void;
  closeConfirmStoryDelete: () => void;
}

const emptyStoriesMessage = (storyQuery: StoryQuery, t: (key: string) => string): string => {
  if (storyQuery.userID) {
    return t('This user hasn\'t publish any stories yet');
  }
  if (storyQuery.entityID) {
    return t('No activity from this group yet');
  }
  if (storyQuery.competitionPledgeID) {
    return t('No one has shared this action yet. Be the first!');
  }
  return t('No activity in this challenge yet');
};
interface StoriesState {
  term: string;
  searched: string;
}
class StoriesComponent extends React.Component<LProps<Props>, StoriesState> {
  constructor(props: LProps<Props>) {
    super(props);
    this.state = {
      term: '',
      searched: ''
    };
  }
  public render() {
    const {term, searched} = this.state;
    const {
      t, stories, pagination, pageStories, pledge, storyQuery,
      closeConfirmStoryDelete, eligible, modal, deleteStory, showPrompt = false
    } = this.props;
    return (
    <div className="cc__stories">
      {/*}
      <div style={{textAlign:"right"}}>
        <input value={term} onChange={(ev)=> this.setState({term:ev.target.value})}/>
        <button onClick={()=> {pageStories(0,term);this.setState({searched:term});}}>Search</button>
      </div>*/}
      <StoryPoints />
      <FeedLiveRefresh />
      {(showPrompt && eligible && pledge) &&
        <StoryCreator competitionPledgeID={pledge.id} pledge={pledge} />
      }
      {(showPrompt && !eligible && pledge) &&
        <UserIneligibleForPledge pledge={pledge} />
      }
      {(!stories || stories.length === 0) && !(showPrompt && eligible && pledge) &&
        <Alert level={StyleState.Info}>
          <div>
            <p>{emptyStoriesMessage(storyQuery, t)}</p>
          </div>
        </Alert>
      }
      <InfiniteScroll
        key={searched}
        pageStart={0}
        className="cc__story_container"
        loadMore={pageStories}
        hasMore={((pagination && pagination.nextPage != null) ? pagination.nextPage : -1) !== -1}
        loader={<div className="loader" key={0}>{t('Loading')} ...</div>}
        threshold={250}
      >
        {stories.map((story: Story) =>
          <StoryComponent
            key={story.id}
            story={story}
          />
        )}
      </InfiniteScroll>
      <ConfirmDeleteModal
        isOpen={modal === Modals.ConfirmStoryDelete}
        confirm={deleteStory}
        cancel={closeConfirmStoryDelete}
      />
      <FlagStoryModal />
    </div>);
  }
}

const mapStateToProps = (state: State, ownProps: ManualProps): Partial<Props> => {
  const { storyQuery } = state;
  const pledgeID = (ownProps.pledge && ownProps.pledge.id) || storyQuery.competitionPledgeID;
  const pledge = ownProps.pledge || state.competitionPledges[pledgeID];
  const eligible = pledge
    ? selectors.isPledgeAccessible(state, pledge)
    : selectors.isUserEligibleForStoryQueryPledge(state);
  return {
    stories: state.stories || [],
    pledge,
    storyQuery,
    eligible,
    modal: state.modal,
    pagination: state.storyPagination
  };
};

const mapDispatchToProps = (dispatch: Dispatch): Partial<Props> => bindActionCreators({
  pageStories: actions.pageStoriesThrottle,
  deleteStory: actions.deleteStory,
  closeConfirmStoryDelete: actions.closeConfirmStoryDelete
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withLocalization('story')
)(StoriesComponent) as React.ComponentClass<ManualProps>;
